// Generated by scripts/styles/generate-public-styles.mjs. Do not edit.
export const publicStylesHref = "/styles/public.a4e38ea717eea932.css"
export const articleStylesHref = "/styles/article-critical.440ac24bb2231778.css"
export const productStylesHref = "/styles/product-critical.bdb5c9b51ecd1214.css"
export const compareStylesHref = "/styles/compare-critical.24b84b600c36157b.css"
export const hubStylesHref = "/styles/hub-critical.f40b9e10dfe1a209.css"
export const brandStylesHref = "/styles/brand-critical.8d71c957a2f56105.css"
